import { OnInit, Component, Input, AfterViewInit } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { AdministrarFuncionarioDTO as AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';

@Component({
    selector: 'app-informacion-personal-component',
    templateUrl: './informacion-personal.component.html',
    styleUrls: ['./../administrar-funcionarios.component.scss']
})
export class InformacionPersonalComponent implements OnInit {

    @Input() datos: AdministrarFuncionarioDTO;
    @Input() existeFuncionario: boolean;
    @Input() deshabilitado: boolean;
    @Input() dominios: DetalleDominio[];
    public rolUsuario: string;
    public consultaDocumento: any;
    public placeholderDate: string;
    isPasaporte = false;
    fechaActual = new Date();

    constructor(
        private utils: UtilService,
        private spinner: NgxSpinnerService,
        private global: GlobalService,
        private urlService: UrlService,
        private alertService: AlertService) {
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
        this.consultaDocumento = [];
    }

    ngOnInit() {
        this.placeholderDate = ConstantesService.SELECCION_FECHA;
        this.obtenerTipoDocumento();
    }

    /**
     * Consulta los tipo de Documento Existente
     */
    public obtenerTipoDocumento() {
        this.consultaDocumento = this.dominios.filter(dominio =>
            dominio.detalleDominioPK.nombreDominio === DominiosService.DOMINIO_TIPO_IDENTIFICACION);
    }

    validarTipoDocumento() {
        if (this.datos.tipoDocumento === DominiosService.TIPO_DOCUMENTO_PASAPORTE
            || this.datos.tipoDocumento === DominiosService.TIPO_DOCUMENTO_EXTRANJERIA) {
            this.isPasaporte = true;
        } else {
            this.isPasaporte = false;
        }
        this.datos.numDocumento = undefined;
    }

    public consultarPersona() {
        if (!this.utils.validarCamposObligatorios(this.datos.numDocumento)
            || !this.utils.validarCamposObligatorios(this.datos.tipoDocumento)) {
            return;
        }
        const serviceProvider = 'ObtenerFuncionario';
        const pathParams: Array<[string, string]> = new Array<[string, string]>();
        pathParams.push(['filterBy=funcionarioPK.numeroIdFuncionario', this.datos.numDocumento]);
        pathParams.push(['funcionarioPK.tipoIdFuncionario', this.datos.tipoDocumento]);
        const url = this.urlService.getUrlFuncionario(
            new UrlControl(serviceProvider, pathParams, null), this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data.length > 0) {
                    this.datos.tipoDocumento = undefined;
                    this.datos.numDocumento = undefined;
                    this.alertService.generateAlertError('El documento ingresado ya se encuentra registrado', '');
                }
            }, err => {
                this.cathException('Se presentó un problema al consultar los datos del ciudadano');
            });
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
